import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";
import React, { memo } from "react";

const ResetIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      {...otherProps}
    >
      <path
        d="M20 11.3253C19.7554 9.56555 18.9391 7.93499 17.6766 6.68482C16.4142 5.43466 14.7758 4.63425 13.0137 4.40688C11.2516 4.17952 9.46362 4.53781 7.9252 5.42657C6.38678 6.31534 5.18325 7.68526 4.5 9.32533M4 5.32533V9.32533H8M4 13.3253C4.24456 15.0851 5.06093 16.7157 6.32336 17.9658C7.58579 19.216 9.22424 20.0164 10.9863 20.2438C12.7484 20.4711 14.5364 20.1128 16.0748 19.2241C17.6132 18.3353 18.8168 16.9654 19.5 15.3253M20 19.3253V15.3253H16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default memo(ResetIcon);
